<template>
  <span
    v-if="count"
    class="flex h-[16px] min-w-[16px] items-center justify-center rounded-[4px] bg-gpx_gray-100 px-1 text-[10px] font-medium text-white"
  >
    {{ count }}
  </span>
</template>

<script setup>
defineProps({
  count: Number,
});
</script>

<style></style>
